var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-nav',{attrs:{"id":"side-nav","vertical":"","fill":""}},[_c('navigation-item',{attrs:{"parent":_vm.parent,"active-node":_vm.activeNode,"active-parent":true,"max-level":_vm.maxLevel,"current-level":0}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }